export enum LauncherFeatureNameTypeEnum {
    'Strech_To_Fit' = 'Fit to screen'
}
